<template>
  <div v-if="loaded" class="settings-card">
    <div class="settings-card__header">
      <div class="settings-card__title">{{ $t('buildInformation.title') }}</div>
      <div class="settings-card__subtitle">{{ $t('buildInformation.subheader') }}</div>
    </div>

    <div v-for="row in rows" :key="row.key" class="build-row">
      <span class="build-row__label">{{ label(row.key) }}</span>
      <span class="build-row__value">{{ formatValue(row) }}</span>
    </div>
  </div>
</template>

<script>
import { formatDateTimeToString } from '../../utils/date'

// Field order shown in the card (OKV-240, per the mockup). Admins get the full set from
// /api/version/Buildinformation (+ the FE build data baked at compile time); everyone else only
// sees the software version (apiVersion from /api/version).
const ADMIN_FIELDS = ['apiVersion', 'schemaDbVersion', 'buildMode', 'buildDate', 'feBuildVersion', 'feBuildDate']
const PUBLIC_FIELDS = ['apiVersion']

export default {
  name: 'buildInformation',
  data() {
    return {
      loaded: false,
      isAdmin: false,
      versionData: {},
    }
  },
  computed: {
    data() {
      if (!this.isAdmin) return this.versionData
      return {
        ...this.versionData,
        feBuildVersion: process.env.VERSION,
        feBuildDate: process.env.BUILD_DATE,
      }
    },
    rows() {
      const fields = this.isAdmin ? ADMIN_FIELDS : PUBLIC_FIELDS
      return fields
        .map((key) => ({ key, value: this.data[key] }))
        .filter((row) => row.value !== null && row.value !== undefined && row.value !== '')
    },
  },
  methods: {
    // i18n labels carry a trailing colon; drop it for the two-column layout.
    label(key) {
      return this.$t(`buildInformation.${key}`).replace(/\s*:\s*$/, '')
    },
    formatValue({ key, value }) {
      switch (key) {
        case 'feBuildDate':
        case 'buildDate':
          return formatDateTimeToString(new Date(value), this.$i18n.locale)
        case 'buildMode':
          return this.$t(`buildInformation.${String(value).toLowerCase()}`)
        default:
          return value
      }
    },
  },
  created() {
    this.isAdmin = this.$store.getters.can_ViewBuildInformation
    const endpoint = this.isAdmin ? '/api/version/Buildinformation' : '/api/version'
    this.get(endpoint, {})
      .then((resp) => {
        this.versionData = resp || {}
      })
      .catch((err) => {
        this.httpErrorsHandler(err)
      })
      .finally(() => {
        this.loaded = true
      })
  },
}
</script>

<style lang="scss" scoped>
.settings-card {
  background: #fff;
  border: 1px solid #e6e8eb;
  border-radius: 10px;
  padding: 20px 24px;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
}
.settings-card__header {
  padding-bottom: 14px;
  margin-bottom: 4px;
  border-bottom: 1px solid #ededf1;
}
.settings-card__title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #1f2430;
}
.settings-card__subtitle {
  margin-top: 4px;
  font-size: 0.875rem;
  color: #8a93a2;
}

.build-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 2px;
  border-bottom: 1px solid #ededf1;
}
.build-row:last-child {
  border-bottom: none;
}
.build-row__label {
  font-size: 0.9rem;
  color: #6b7688;
}
.build-row__value {
  font-size: 0.9rem;
  font-weight: 600;
  color: #1f2430;
  text-align: right;
  font-variant-numeric: tabular-nums;
}
</style>
